import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateCreateMailing = {
  createMailing: { data: null, loading: false, error: null },
};

export const createMailing = createAsyncThunk('user/createMailing', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(`${process.env.REACT_APP_SERVER_API}/chat/mailing`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCreateMailing = {
  [createMailing.pending]: (state) => {
    // state.createMailing.data = null;
    state.createMailing.loading = true;
    state.createMailing.error = null;
  },
  [createMailing.fulfilled]: (state, action) => {
    state.createMailing.loading = false;
    state.createMailing.data = action.payload;
    state.createMailing.error = null;
  },
  [createMailing.rejected]: (state, action) => {
    state.createMailing.loading = false;
    state.createMailing.error = action.payload;
  },
};
